import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, useFormState } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Redirect } from 'react-router-dom';

import AuthBackground from 'components/AuthBackground';
import Button from 'components/Button';
import Input from 'components/Input';

import { resetPassword as TEXT } from 'locales/en';
import { resetPassword, setNeedVerification } from 'redux/slices/auth';
import { useQueryParams } from 'hooks';
import PATHS from 'routes/paths';
import schema from './schema';
import Verify from 'pages/SignUp/Verify.admin';

const ResetPassword = () => {
  const dispatch = useDispatch();
  const query = useQueryParams();
  const token = query.get('token');

  const { needVerification, resetPasswordEmail } = useSelector(
    (state) => state.auth
  );
  const { register, handleSubmit, control } = useForm({
    resolver: yupResolver(schema),
  });
  const { errors, isSubmitting } = useFormState({ control });

  const onSubmit = (data) => {
    return dispatch(resetPassword({ ...data, token }));
  };

  if (!token) return <Redirect to={PATHS.login} />;

  return needVerification ? (
    <Verify
      onClickReturn={() => {
        dispatch(setNeedVerification(false));
        window.location.replace(PATHS.login);
      }}
    />
  ) : (
    <AuthBackground header1={TEXT.header1} header2={TEXT.header2}>
      <form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col justify-between"
      >
        <div>
          <Input
            label={TEXT.email}
            name="email"
            type="email"
            register={register}
            required
            error={errors.email?.message}
            defaultValue={resetPasswordEmail}
          />
          <Input
            label={TEXT.password}
            name="password"
            type="password"
            register={register}
            required
            error={errors.password?.message}
          />
          <Input
            label={TEXT.password_confirmation}
            name="password_confirmation"
            type="password"
            register={register}
            required
            error={errors.password_confirmation?.message}
          />
        </div>
        <div className="flex justify-end items-center mt-2">
          <Button
            className="bg-javelin-blue-dark w-44 p-4 font-bold text-base rounded-full mt-2 col-start-2 md:col-start-3"
            type="submit"
            title={TEXT.submit}
            showSpinner={isSubmitting}
          />
        </div>
      </form>
    </AuthBackground>
  );
};

export default ResetPassword;
